module.exports = __webpack_public_path__ + "img/Patch5.2.76384fbb.webp";